import React, { Component,  useState, useEffect  } from 'react';
import './EstruturaTO3.css';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import paredocientec from '../../assets/videos/paredocientec.mp4';
import interativo2Ativo1 from '../../assets/svgs/interativoAtivo 1.svg';        
import Dt2 from "../../assets/fundos/Dt2.jpg";
import controleremoto from '../../assets/svgs/Controle-01.svg';      
import $, { when } from "jquery";
import { debounce, throttle } from 'lodash';
import seta from '../../assets/svgs/more-white.svg';     

class EstruturaTO3 extends Component {
    componentDidMount() {

        if(window.matchMedia("(max-width: 600px)").matches){
    
        }
        else{
          if($( ".magazinenova" ).mousemove=true){
            $( ".magazinenova" ).mousemove(function( event ) {

              $("#TO3desapa").fadeIn();
        
              
            });
          }
          else{
            $("#TO3desapa").fadeOut();
    
          }
    
        }
    
    
    
        $("#TO3dimensao").click(function()
        
        {

          $(".sidebar-wrapper").removeClass("show-sidebar", 500);
          $(".menuuu").addClass("todonone");
          $(".ffechar").addClass("todonone", 500);

          $("#TO3video").prop('muted', false);
          $("#TO3dimensao").addClass("todonone");
          $("#TO3dimensao2").removeClass("todonone");
          $("#TO3desapa2").addClass("todonone");
          $("#TO3video").addClass("pulo");

          $("#TO7dimensao").removeClass("todonone");
          $("#TO7desapa2").removeClass("todonone");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7video").removeClass("pulo");
          $("#TO7local1").removeClass("pulo");
          $("#TO7video").prop('muted', true);

          $("#TO6dimensao").removeClass("todonone");
          $("#TO6desapa2").removeClass("todonone");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6video").removeClass("pulo");
          $("#TO6local1").removeClass("pulo");
          $("#TO6video").prop('muted', true);

          $("#TO5dimensao").removeClass("todonone");
          $("#TO5desapa2").removeClass("todonone");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5video").removeClass("pulo");
          $("#TO5local1").removeClass("pulo");
          $("#TO5video").prop('muted', true);

          $("#TO4dimensao").removeClass("todonone");
          $("#TO4desapa2").removeClass("todonone");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4video").removeClass("pulo");
          $("#TO4local1").removeClass("pulo");
          $("#TO4video").prop('muted', true);

          $("#TO8dimensao").removeClass("todonone");
          $("#TO8desapa2").removeClass("todonone");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8video").removeClass("pulo");
          $("#TO8local1").removeClass("pulo");
          $("#TO8video").prop('muted', true);

          $("#TO2dimensao").removeClass("todonone");
          $("#TO2desapa2").removeClass("todonone");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2video").removeClass("pulo");
          $("#TO2local1").removeClass("pulo");
          $("#TO2video").prop('muted', true);

          $("#dimensao").removeClass("todonone");
          $("#desapa2").removeClass("todonone");
          $("#obra1").removeClass("pulo");
          $("#obra1").removeClass("pulo");
          $("#video").removeClass("pulo");
          $("#local1").removeClass("pulo");
          $("#video").prop('muted', true);
    
        }
        );
        $("#TO3dimensao2").click(function()
        
        {
          $(".menuuu").removeClass("todonone");
          $("#TO3video").prop('muted', true);
          $("#TO3dimensao2").addClass("todonone");
          $("#TO3dimensao").removeClass("todonone");
          $("#TO3desapa2").removeClass("todonone");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3video").removeClass("pulo");
          $("#TO3local1").removeClass("pulo");
        }
        );
    
    
        $("#TO3magazinenova").click(function(){
          $("#TO3desapa").delay('slow').fadeIn();
            
        
    
          setTimeout(
            function() 
            {
    
              
              var desaparecendo = 'todonone';

              $("#TO3desapa").fadeOut();
            }, 30000);
    
        });
    
        (function () {
    
          $("#TO3botomenu").click(function () {
            $( this ).slideUp().fadeOut(10000);
            $("#TO3hold1 ").addClass("cc");
            $("#TO3botoobras ").addClass("cc");
            $("#TO3hold3 ").addClass("cc");
            $("#TO3hold4 ").addClass("cc");
            $("#TO3hold5 ").addClass("cc");
            $("#TO3hold1 ").removeClass("transiopaca");
            $("#TO3botoobras ").removeClass("transiopaca");
            $("#TO3hold3 ").removeClass("transiopaca");
            $("#TO3hold4 ").removeClass("transiopaca");
            $("#TO3hold5 ").removeClass("transiopaca");
            setTimeout(function(){
              setTimeout(function(){
                $("#TO3hold5 ").addClass("transiopaca");
                setTimeout(function(){
                  $("#TO3hold4 ").addClass("transiopaca");
                  setTimeout(function(){
                    $("#TO3hold3 ").addClass("transiopaca");
                    setTimeout(function(){
                      $("#TO3botoobras ").addClass("transiopaca");
                      $("#TO3hold1 ").addClass("transiopaca");
                      setTimeout(function(){
                        $("#TO3hold1 ").removeClass("cc");
                        $("#TO3botoobras ").removeClass("cc");
                        $("#TO3hold3 ").removeClass("cc");
                        $("#TO3hold4 ").removeClass("cc");
                        $("#TO3hold5 ").removeClass("cc");
                        $("#TO3botomenu").slideDown();
                      },1000);
                    },1000);
    
    
                  },1000);
    
    
                },1000);
    
              },1000);
    
    
    
    
    
    
    
              }, 3000);

          });
    
          var qua = $('.resposta');
          var $target = $('.gatilhoObra'),
            animationClass = 'respostaGatilho',
            animationClass2 = 'respostaGatilho2',
            offset = $(window).height() * 1 / 10;
    
    
    
          function animeScroll() {
            $("#TO3desapa").fadeOut();
            
        
    
            setTimeout(
              function() 
              {
                var desaparecendo = 'todonone';

                $("#TO3desapa").fadeIn();
              }, 2000);
    
    
            var documentTop = $(document).scrollTop();
    
            $target.each(function (index) {
    
              var itemTop = $(this).offset().top;
    
              if (documentTop > itemTop - offset) {
                $("#TO3botoobras").addClass(animationClass2);
                
              }
              else{
                $("#TO3boto" + index).removeClass(animationClass);
                  
              }
    
              if (documentTop > itemTop - offset) {
                $("#TO3boto" + index).addClass(animationClass);
                
                if (documentTop > itemTop * 2 - offset * 2) {
                  $("#TO3boto" + index).removeClass(animationClass);
                  
                }
                if (documentTop > itemTop){
                  $("#TO3boto" + index).removeClass(animationClass);
                  
                }
              }
            }
    
            
    
            );
          }
    
         
    
          $(document).scroll(debounce(function () {
            animeScroll();
          }, 200));
        })();
    
    
        $('.bolinhas a[href^="#TO3"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
    
        $('.grandeMenu a[href^="#TO3"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
      }
    render() {
        return (
            <div id="TO3obra1" className="displayTO3 gatilhoObra"> {this.props.children}
                <div id="TO3local1"className="videolocalTO3" style={{backgroundImage: 'url(' + {Dt2} +')'}}>
                <div class="sidebar-wrapper">
                        <div class="sidebar">
                            <h3> 2017 - 2018   </h3>
                            <h2 class="sidebar-titulo">PAREDÃO ELETRÔNICO</h2>
                            <p class="descricao">Intervenção envolvendo um Paredão (sound system) com  inserção da interatividade nessa estrutura como ciclos de interações luminosas, sonoras e performativas; também são introduzidos comandos centrais e de agenciamento  através de aplicativos celulares. Uma das composições  utiliza  sons  extraídos a partir da voz e da pele de maneira dinâmica e interativa através do uso de celulares representando, na estrutura do discurso musical, a presença do corpo.
 </p>
 <a className="botaops repon"  href="https://editor.p5js.org/10Dimensoes/present/gQqP2G2x9">obra interativa</a>
                        </div>
                        <div class="menuuu" id="menuuu"><i class="fa fa-bars fa-2x">
                        <img className="ring button" src={seta} alt=""/>
                        
                            
                            
                            
                            
                            </i></div>
                    </div>
                    <div className="videoTO3" >
                        <video controlsList = "nofullscreen nodownload noremoteplayback" poster="a" id="TO3video" playsInline autoPlay muted loop>
                            <source src={paredocientec } type="video/mp4">
                            </source>
                        </video>
                    </div>
                    <div className="sobrepo1TO4"></div>
                    <div className="sobrepo2TO4"></div>
                    <div className="sobrepo3TO4"></div>

                    
                </div>
                <div className="ffechar todonone">
                       <i> FECHAR </i>
                    </div>
                <div className="magazinenova" id="TO3magazinenova">
                    <div id="TO3dimensao"className="controleremoto">
                        <img src={controleremoto} alt=""/>
                    </div>
                    <div id="TO3dimensao2"className="controleremoto2 todonone">
                    <img src={controleremoto} alt=""/>
                        
                </div>
                </div>
            </div>
        );
    }
}
 
export default EstruturaTO3  ;